import { render, staticRenderFns } from "./FormPicker.vue?vue&type=template&id=f8b967a0&"
import script from "./FormPicker.vue?vue&type=script&lang=js&"
export * from "./FormPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports